import { DescriptionWindowActionType } from '../../types/descriptionWindow'

export function showDescriptionWindow() {
    return {
        type: DescriptionWindowActionType.SHOW_DESCRIPTION_WINDOW,
    }
}

export function hideDescriptionWindow() {
    return {
        type: DescriptionWindowActionType.HIDE_DESCRIPTION_WINDOW,
    }
}

export function changeDescriptionWindowCoordinates(coordinates: {
    x: number
    y: number
}) {
    return {
        type: DescriptionWindowActionType.CHANGE_COORDINATES,
        payload: coordinates,
    }
}

export function changeDescriptionWindowSize(size: {
    width: number
    height: number
}) {
    return {
        type: DescriptionWindowActionType.CHANGE_SIZE,
        payload: size,
    }
}

export function setDescriptionWindowData(data: {
    header: string
    description: string
}) {
    return {
        type: DescriptionWindowActionType.SET_DESCRIPTION_DATA,
        payload: data,
    }
}
